module.exports = __webpack_public_path__ + "static/img/live-layout04.4d65ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/live-layout04.png
// module id = 396
// module chunks = 1